<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import DashboardMain from "./components/dashboard/DashboardMain.vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
export default {
  name: "app",
  components: {
    DashboardMain,
  },
};
</script>

<style>
.app {
  background: #fff;
  height: 8rem;
  border: solid 2px #e5e5e5;
  margin-bottom: 2rem;
  position: relative;
}
.app img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 80%;
}
.col-sm-3 {
  max-width: 250px;
}
button.add-page-btn {
  background: transparent;
  border: none;
  color: #fff;
  margin-top: 2rem;
  cursor: pointer;
}
button.add-page-btn span {
  display: block;
  margin-top: 10px;
  font-size: 1.2rem;
}
button.add-page-btn i.fa-plus {
  font-size: 2rem;
  border: solid 4px #fff;
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  line-height: 58px;
}

iframe {
  width: calc(100vw - 80px);
  /* height: 100%; */
  height: calc(100vh - 75px); /* fallback if css var is not supported*/
  height: calc(calc(var(--vh, 1vh) * 100) - 75px);
  display: block;
  position: absolute;
  left: 80px;
  top: 75px;
  border: 0;
}
.glide__slides,
.glide__track {
  overflow: initial;
}
.glide__slides {
  margin: auto;
  width: fit-content !important;
  display: var(--glide_display);
}
</style>
